import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const { resetPassword } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    const { error: resetError } = await resetPassword(email);

    if (resetError) {
      setError('Şifre sıfırlama işlemi başarısız oldu. Lütfen tekrar deneyin.');
      setLoading(false);
      return;
    }

    setSuccess('Şifre sıfırlama linki e-posta adresinize gönderildi!');
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-stone-800 tracking-tight">ProLog</h1>
          <p className="text-stone-500 mt-2 text-sm">Projelerinizi organize edin</p>
        </div>

        <div className="bg-white rounded-xl p-8 shadow-sm border border-stone-200">
          <h2 className="text-xl font-semibold text-stone-800 mb-2 text-center">Şifremi Unuttum</h2>
          <p className="text-stone-500 text-sm text-center mb-6">
            E-posta adresinizi girin, size şifre sıfırlama linki gönderelim.
          </p>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
              {error}
            </div>
          )}

          {success && (
            <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg text-green-600 text-sm">
              {success}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-stone-700 mb-1">
                E-posta
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-2.5 rounded-lg border border-stone-300 text-stone-800 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                placeholder="ornek@email.com"
              />
            </div>

            <button
              type="submit"
              disabled={loading || !!success}
              className="w-full py-2.5 bg-stone-800 text-white rounded-lg text-sm font-medium hover:bg-stone-900 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
            >
              {loading ? 'Gönderiliyor...' : 'Sıfırlama Linki Gönder'}
            </button>
          </form>

          <div className="mt-6 text-center text-sm text-stone-500">
            <Link to="/login" className="text-amber-600 hover:text-amber-700 font-medium">
              Giriş sayfasına dön
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}